import { Handle, NodeProps, Position } from 'reactflow';
import { Filter } from 'lucide-react';
import { PipelineNodeData } from '../../types/pipeline';

export default function FilterNode({ data, selected }: NodeProps<PipelineNodeData>) {
  return (
    <div
      className={`rounded-lg border bg-white px-3 py-2 shadow-sm ${
        selected ? 'border-purple-500 ring-2 ring-purple-200' : 'border-purple-200'
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-purple-500" />
      <Handle type="source" position={Position.Right} className="!bg-purple-500" />
      <div className="flex items-center gap-2 text-sm font-semibold text-purple-700">
        <Filter className="h-4 w-4" />
        <span>{data.label}</span>
      </div>
      {data.description && (
        <p className="mt-1 text-xs text-slate-500">{data.description}</p>
      )}
    </div>
  );
}
